import { __ } from '~/locale';

export const ADD_DROPDOWN_CLICK = 'click_add_dropdown';
export const NEW_FILE_CLICK = 'click_new_file';
export const UPLOAD_FILE_CLICK = 'click_upload_file';
export const NEW_DIRECTORY_CLICK = 'click_new_directory';
export const NEW_BRANCH_CLICK = 'click_new_branch';
export const NEW_TAG_CLICK = 'click_new_tag';

export const NO_MODIFY_PERMISSION_MESSAGE = __("You don't have permission to modify this file.");
